<template>
    <div v-bind:class="$style.logo">
        <RouterLink
            v-bind:to="{
                name: 'home',
            }"
        >
            <AppSvg
                icon-color="#f5f5f5"
                view-box="0 0 288.3 70"
                v-bind:height="mq_isMediumPlus ? 31 : 31"
                v-bind:width="150"
                title="Citizen J Logo"
            >
                <g>
                    <path fill="#fff" d="M31.1 43.2c.1 3.1.2 4.4.2 6 0 10.2-3.8 15.1-11.5 15.1-7.4 0-11.2-4.6-11.2-13.7V19.3c0-9 3.8-13.7 11.2-13.7 7.7 0 11.5 5 11.5 14.9 0 1.4 0 2.3-.2 4.5h-7.9c.2-1.8.2-2.6.2-3.9 0-6.3-.8-8-3.6-8-2.6 0-3.2 1.3-3.2 6.2v31.3c0 5 .7 6.2 3.2 6.2 2.8 0 3.6-1.7 3.6-7.8 0-1.7-.1-3.2-.2-5.9h7.9zm21.3 20.2h-7.9V6.5h7.9v56.9zm19.5-49.5h-7.4V6.5h23.1v7.4h-7.8v49.5h-7.9V13.9zm35.7 49.5h-7.9V6.5h7.9v56.9zm12.9-7.4l14.2-42.1h-12.5V6.5h20.5v7.4L128.4 56h14.2v7.4h-22.1V56zm54.2-49.5v7.4h-11.3v16h7.9v7.4h-7.9V56h11.9v7.4h-19.9V6.5h19.3zm37.9 56.9h-7.9l-9.4-29.9v29.9h-7.9V6.5h6.8L204.7 40V6.5h7.9v56.9zm45.7-56.9v43.3c0 5.1-.2 6.8-.9 8.4-1.6 4.1-4.4 5.2-12.1 5.2v-7.9h.6c3.4 0 4.4-1.1 4.4-5v-44h8z" />
                    <path d="M272 54.9h7.9v8.5H272v-8.5z" fill="#ef4141" />
                </g>
            </AppSvg>
        </RouterLink>
    </div>
</template>

<script>
    import MediaQueries from '@mixins/MediaQueries';

    export default {
        /**
         * Mixins are a flexible way to distribute reusable functionalities for Vue components.
         * A mixin object can contain any component options. When a component uses a mixin,
         * all options in the mixin will be “mixed” into the component’s own options.
         *
         * @link https://vuejs.org/v2/guide/mixins.html
         */
        mixins: [
            MediaQueries,
        ],
    };
</script>

<style lang="scss" module>
    @import '@design';

    .logo {
        @apply mt-2;
        max-width: 85%;
        height: 2.9rem;
    }
</style>
